import { render } from "./FacturasGlobalesNew.vue?vue&type=template&id=5ff68332&scoped=true"
import script from "./FacturasGlobalesNew.vue?vue&type=script&lang=js"
export * from "./FacturasGlobalesNew.vue?vue&type=script&lang=js"

import "./FacturasGlobalesNew.vue?vue&type=style&index=0&id=5ff68332&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff68332"]])

export default __exports__